import { SearchOutlined } from "@ant-design/icons";
import { useSelect } from "@refinedev/antd";
import { useTranslate } from "@refinedev/core";
import { Form, Input, Select, Button, DatePicker, Flex } from "antd";

const { RangePicker } = DatePicker;

interface ListFilterProps {
    formProps: any;
    isAdmin: boolean;
}

export const ListFilter = ({ formProps, isAdmin }: ListFilterProps) => {

    const _t = useTranslate();
    const { selectProps: accountSelectProps } = useSelect({
        resource: "accounts",
        optionLabel: "name",
    });

    return (
        <Form layout="horizontal" {...formProps} style={{ margin: 0 }}>
            <Form.Item label="Search" name="q" className="hidden">
                <Input
                    size="middle"
                    placeholder="ID, Title, Content, etc."
                    prefix={<SearchOutlined />}
                />
            </Form.Item>
            
            <Flex 
                gap="middle" 
                wrap="nowrap" 
                align="flex-end"                
            >
                <Form.Item
                    name="createdAt"
                    className="mb-0"
                >
                    <RangePicker size="middle"/>
                </Form.Item>
                
                <Form.Item
                    label={_t("orders.fields.status")}
                    name="status"
                    className="hidden"
                >
                    <Select
                        allowClear
                        size="middle"
                        options={[
                            {
                                label: _t("orders.fields.statusValues.all"),
                                value: "all",
                            },
                            {
                                label: _t("orders.fields.statusValues.submitted"),
                                value: "submitted",
                            },
                            {
                                label: _t("orders.fields.statusValues.ongoing"),
                                value: "ongoing",
                            },
                            {
                                label: _t("orders.fields.statusValues.completed"),
                                value: "completed",
                            },
                            {
                                label: _t("orders.fields.statusValues.sav"),
                                value: "sav",
                            },
                            {
                                label: _t("orders.fields.statusValues.canceled"),
                                value: "canceled",
                            },
                        ]}
                        placeholder={_t("orders.fields.status")}
                    />
                </Form.Item>
                
                <Form.Item
                    name="vin"
                    className="mb-0"
                >
                    <Input
                        size="middle"
                        placeholder={_t('orders.fields.vin')}
                    />
                </Form.Item>
                
                {isAdmin && (
                    <>
                        <Form.Item
                            name="account"
                            className="mb-0"
                        >
                            <Select
                                {...accountSelectProps}
                                allowClear
                                size="middle"
                                placeholder="Sélectionner un client"
                            />
                        </Form.Item>
                        
                        <Form.Item
                            name="billingMode"
                            className="mb-0"
                        >
                            <Select
                                allowClear
                                size="middle"
                                options={[
                                    {
                                        label: _t("accounts.fields.billingModeValues.prepaid"),
                                        value: "prepaid",
                                    },
                                    {
                                        label: _t("accounts.fields.billingModeValues.postpaid"),
                                        value: "postpaid",
                                    },
                                    {
                                        label: _t("accounts.fields.billingModeValues.free"),
                                        value: "free",
                                    },
                                ]}
                                placeholder={_t('accounts.fields.billingMode')}
                            />
                        </Form.Item>
                    </>
                )}
                
                <Form.Item className="mb-0">
                    <Button htmlType="submit" type="primary" size="middle">
                        {_t("buttons.filter")}
                    </Button>
                </Form.Item>
            </Flex>
        </Form>
    );
};